import React from 'react';
import StyledFadeInDotIndicator from '../../styled/FadeInDotIndicator';

interface IFadeInDotIndicator {
  images: number[];
  activeStep: number;
}

const FadeInDotIndicator = ({ images, activeStep }: IFadeInDotIndicator) => {
  return (
    <>
      <StyledFadeInDotIndicator steps={images} activeStep={activeStep} />
    </>
  );
};

export default FadeInDotIndicator;
